var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinalizing({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2797_2764",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2797_2764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 18.8V16H17.5V19.2L19.65 21.35L20.35 20.65L18.5 18.8ZM12 4L6.075 7.425L12 10.85L17.925 7.425L12 4ZM3 15.975V8.025C3 7.65833 3.0875 7.325 3.2625 7.025C3.4375 6.725 3.68333 6.48333 4 6.3L11 2.275C11.1667 2.19167 11.3292 2.125 11.4875 2.075C11.6458 2.025 11.8167 2 12 2C12.1833 2 12.3583 2.025 12.525 2.075C12.6917 2.125 12.85 2.19167 13 2.275L20 6.3C20.3167 6.48333 20.5625 6.725 20.7375 7.025C20.9125 7.325 21 7.65833 21 8.025V12H19V9.1L11.975 13.15L5 9.1V15.95L11 19.425V21.725L4 17.7C3.68333 17.5167 3.4375 17.275 3.2625 16.975C3.0875 16.675 3 16.3417 3 15.975ZM18 24C16.6167 24 15.4375 23.5125 14.4625 22.5375C13.4875 21.5625 13 20.3833 13 19C13 17.6167 13.4875 16.4375 14.4625 15.4625C15.4375 14.4875 16.6167 14 18 14C19.3833 14 20.5625 14.4875 21.5375 15.4625C22.5125 16.4375 23 17.6167 23 19C23 20.3833 22.5125 21.5625 21.5375 22.5375C20.5625 23.5125 19.3833 24 18 24Z",
    fill: "#2C3E50"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalizing);
export default __webpack_public_path__ + "static/media/FINALIZING.9b80bf35f65e91d8be7b95fac02829e4.svg";
export { ForwardRef as ReactComponent };